import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";

import ContainerBase from "lib/ContainerBase";

import products from "state/selectors/products";

import ProductsView from "views/ProductsView";

import { GlobalState, Products, GlobalSettings } from "types";

interface StoreProps {
  products: Products | null;
  globalSettings: GlobalSettings;
}

type Props = RouteComponentProps & StoreProps;

class ProductsContainer extends ContainerBase<Props, typeof ProductsView> {
  view = import("views/ProductsView");
}

const mapStateToProps = (state: GlobalState) => ({
  products: products(state),
  globalSettings: state.applicationUI.globalSettings
});

export default connect(mapStateToProps)(ProductsContainer);
